import React, { useState } from "react"
import clsx from "clsx"
import LazyLoad from "react-lazyload"

import { Asset, Link } from "components"

function Card({ size, heroHeading, slug, heroImage, heroVideo }) {
  const [isHovering, setIsHovering] = useState(false)

  const HREF = `/why/${slug}/`

  return (
    <li className="flex">
      <Link
        href={HREF}
        className="flex flex-col justify-between w-full bg-white focus:outline-none focus:text-violet text-darkNavy ring-1 ring-mineralGray focus:ring-violet"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div
          className={clsx(
            "space-y-4",
            size === "Large" && "pt-8 px-6 sm:px-fluidMargin md:px-8",
            size === "Small" && "px-6 sm:px-fluidMargin md:px-6 pt-8 md:pt-6"
          )}
        >
          <h3
            className={clsx(
              "text-current md:max-w-sm",
              size === "Large" && "h3",
              size === "Small" && "h5"
            )}
          >
            {heroHeading}
          </h3>
          <p className="body">
            <span
              className={clsx(
                "text-link transition-opacity duration-150 ease-out focus:opacity-75",
                isHovering === true && "opacity-75"
              )}
            >
              Learn More
            </span>
          </p>
        </div>
        <div
          className={clsx(
            "select-none aspect-w-12 aspect-h-11",
            size === "Large" && "md:aspect-w-4 md:aspect-h-3"
          )}
          style={{ marginRight: "0.5px", marginBottom: "0.5px" }}
        >
          {heroImage && (
            <Asset
              asset={heroImage}
              objectFit="contain"
              objectPosition={heroVideo ? "right" : "center"}
              style={{ position: "absolute" }}
            />
          )}
          {heroVideo && (
            <LazyLoad
              classNamePrefix="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
              once
            >
              <Asset
                className="absolute top-0 bottom-0 left-0 right-0 object-contain object-right w-full h-full"
                asset={heroVideo}
              />
            </LazyLoad>
          )}
        </div>
      </Link>
    </li>
  )
}

export default Card
